import { Controller } from "stimulus";

export default class extends Controller {

  connect() {

    const urlParams = new URLSearchParams(window.location.search);
    if(urlParams.get('reload') === "true"){
      const url = new URL(window.location.href);
      const search_params = url.searchParams;
      search_params.delete('reload');
      url.search = search_params.toString();
      window.location.href = url.toString();
    }
    window.addEventListener("load", () => {  
      document.getElementsByName("button").forEach(element => {
        element.addEventListener("click", function() {
          document.getElementById("modal").classList.add("is-open");
        });
      });

      const acc = document.querySelectorAll(".accordion");

      for (let i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function () {
          this.classList.toggle("active");
          const panel = this.previousElementSibling;
          if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
          } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
          }
        });
      }
      const todayWorkingText = document.querySelector("#today-working-text");
      const openingHours = document.querySelector("#opening-hours");
      if (!openingHours) return;
      const transformed = openingHours.innerText.replaceAll("=>", ":");
      const jsonData = JSON.parse(transformed);
      const currentDate = new Date();
      const currentDay = currentDate.toLocaleString(
        'en-US', {weekday: 'long'}
      ).toLowerCase();
      let currentDayTimes;
      let yesterdayTimes = jsonData.sunday;
      for (var key of Object.keys(jsonData)) {
        if(currentDay == key){
          currentDayTimes = jsonData[key];
          break;
        }
        yesterdayTimes = jsonData[key];
      }
      const currentTime = (currentDate.getHours() < 10 ? "0" : "") + currentDate.getHours() + ":" + (currentDate.getMinutes() < 10 ? "0" : "") + currentDate.getMinutes();
      
      const urlParams = new URLSearchParams(window.location.search);
      const current_locale = urlParams.get('locale')
      if (current_locale === "en"){
        var translations = { 
          opened: "Open now",
          closed: "Closed"
        }
      } else{
        var translations = { 
          opened: "Jetzt geöffnet", 
          closed: "Jetzt geschlossen"
        }
      }

      todayWorkingText.innerText = translations.closed;
      todayWorkingText.classList.add("closed");


      if(currentDayTimes){
          currentDayTimes.forEach(element => {
          if((currentTime >= element.from && currentTime <= element.to) || (currentTime >= element.from && currentTime >= element.to && element.to <= element.from) || (yesterdayTimes[yesterdayTimes.length - 1].to >= currentTime && yesterdayTimes[yesterdayTimes.length - 1].to < yesterdayTimes[yesterdayTimes.length - 1].from)){
            todayWorkingText.innerText = translations.opened;
            todayWorkingText.classList.remove("closed");
            todayWorkingText.classList.add("open");
            return;
          }
        });
      }


    });
  }
}